import React from 'react';

import {labels} from '../../../../../../util/utils';
import {engagementStatus} from '../../../../../../util/uiconstants';

import OutputText from '@ey/canvascoreservices/OutputText';

export const prop = 'engDes';

const NameColumn = (item) => {
	let txt = item[prop];
	if (item.engStatus === engagementStatus.archived) txt = `${txt} (${labels.engagementArchived})`;
	const props = {
		children: txt,
		title: txt
	};

	return <OutputText body2 light {...props} ellipsis />;
};

export const config = (labels) => ({
	id: 'engagementNameColumn',
	label: labels.engagementLabel,
	propName: prop,
	width: 'minmax(var(--px-190), 3fr)',
	sortBy: prop,
	customCell: (item) => <NameColumn {...item} />
});
